import styled from 'styled-components'

export const ScrollerWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  position: relative;
`

export const SectionList = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const SectionBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const SectionLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0 2px 0;
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: var(--color-bg);
`

export const SectionLabelText = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.15px;
  color: var(--color-text-muted);
`

export const SectionLabelBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 16px;
  padding: 0 8px;
  border-radius: 2px;
  background-color: #2F5BFF;
  color: #ffffff;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 10px;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: center;
  flex-shrink: 0;
  box-sizing: border-box;
`

export const IndexBar = styled.div`
  position: sticky;
  top: calc(50vh - 80px);
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 4px 0 4px 4px;
  width: 30px;
  flex-shrink: 0;
  user-select: none;
`

export const IndexItem = styled.button<{ $active: boolean }>`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  width: auto;
  padding: 0 6px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-size: 9px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.3px;
  color: ${({ $active }) => ($active ? 'var(--color-bg)' : 'var(--color-accent)')};
  background-color: ${({ $active }) => ($active ? 'var(--color-accent)' : 'transparent')};
  border: 1px solid ${({ $active }) => ($active ? 'var(--color-accent)' : 'var(--color-neutral-200)')};
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;

  &:hover {
    background-color: ${({ $active }) =>
      $active ? 'var(--color-accent-light)' : 'var(--color-neutral-400)'};
  }
`
